import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import {
  SearchContainer,
  SearchIconWrapper,
  SearchInput,
} from './TransferToAgencyModal.styles';

interface AgencySearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

function AgencySearchInput({
  value,
  onChange,
  placeholder = 'Search agencies...',
}: AgencySearchInputProps) {
  return (
    <SearchContainer>
      <SearchIconWrapper>
        <MagnifyingGlassIcon width={14} height={14} />
      </SearchIconWrapper>
      <SearchInput
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </SearchContainer>
  );
}

export default AgencySearchInput;
